export default {
 template: `
  <span class="wtgticket" ng-if="$ctrl.showId">
   {{$ctrl.ticket.id}}&nbsp;&nbsp;
   <span class="tstamp" ng-if="!!$ctrl.ticket.ts">
    {{$ctrl.ticket.ts|date:"yyyy-MM-dd HH:mm"}}
   </span>
  </span>
  <div class="wtgticket" ng-if="$ctrl.showTitle" style="font-size:small">
   {{$ctrl.ticket.title}}
  </div>
 `.replace(/\n\s+/g,''),
 bindings: {
  ticket: "<",          // wtg_conversation object
  showId: "<",
  showTitle: "<"
 },
 controller: function($scope) {
  var that = this;
  that.$onInit=function(){
   if(angular.isUndefined(that.showId)) that.showId = true;
  };
 }
};
/* vim:set ts=8 sw=1 expandtab: */

